import { Injectable } from '@angular/core';
import { SearchCriteria, Clause } from '../../search/models/search-filter-model';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchEvent } from '../../search/models/search-event';
import { ReceiptDataService } from './receipt-data.service';
import { ReceiptBackendService } from './receipt-backend.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { DetailedEntityDataEditorService } from '../searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { DataTableConfig } from '../../search/models/data-table-config';
import { MANUAL_EDIT, PropertyChangeEvent } from '../../models/property-change-event';
import { Row } from 'primeng/primeng';
import { isBoolean } from 'util';
import { ConfirmDialogService } from 'sce-core';
import { REFRESH_SEARCH_EVENT } from '../../search/search-constants';
import { COMMONPROPERTIES } from 'app/shared/models/common-fields';

@Injectable()
export class ReceiptDataEditorService extends DetailedEntityDataEditorService {

  // We have extended from the default searchable entity. Hence redeclaring the following services for receipt
  protected dataService: ReceiptDataService;
  protected backendService: ReceiptBackendService;
  protected confirmDialogService: ConfirmDialogService;
  private externReceiptKeyTableIds = ['asntd','trtd','ixdocktd','oxdocktd'];

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
  }

  public isnewLine: boolean = false;
  protected getSkuProperty(property) {
    let skuProperty;
    if (this.dataService.entityConfig.getType() === 'PO' || property === 'commodity') {
      skuProperty = 'commodity';
    } else {
      skuProperty = 'sku';
    }
    return skuProperty;
  }

  protected createDefaultSearchCriteria(currentRow: any, selectedColumnValue: any, property: any) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition = this.createSearchCondition(1);
    defaultCondition.isReadOnly = true;
    defaultCondition.isMandatory = true;
    const defaultClause = new Clause();
    defaultClause.operation = '=';
    // to add auto filter
    const defaultClause1 = new Clause();
    const defaultClause2 = new Clause();
    defaultClause1.operation = '=';
    if (property === 'storerKey' || property === 'storerName') {
      defaultClause.column = 'storerType';
      defaultClause.value = '1';
    } else if (property === this.getSkuProperty(property)) {
      defaultClause.column = 'storerKey';
      let selectedStorer = this.dataService.primaryDataMap['storerKey'].cVal;
      if (selectedStorer === '') {
        selectedStorer = '*';
      }
      defaultClause.value = selectedStorer;
      // LFWM-2090 : auto filter in lookup
      if (selectedColumnValue && selectedColumnValue.trim() !== '') {​​​​​
        defaultClause1.column = 'sku';
        defaultClause1.value = selectedColumnValue;
      }​​​​​
    } else if (property === 'toLoc') {
      defaultClause.column = 'facility';
      defaultClause.value = this.dataService.primaryDataMap['facility'].cVal;
      // LFWM-2090 : auto filter in lookup
      if (selectedColumnValue && selectedColumnValue.trim() !== '') {​​​​​
        defaultClause1.column = 'locId';
        defaultClause1.value = selectedColumnValue;
      }​​​​​
    } else if (property === 'putawayLoc') {
      defaultClause.column = 'facility';
      defaultClause.value = this.dataService.primaryDataMap['facility'].cVal;
     // LFWM-2090 : auto filter in lookup
      if (selectedColumnValue && selectedColumnValue.trim() !== '') {​​​​​
        defaultClause1.column = 'locId';
        defaultClause1.value = selectedColumnValue;
      }​​​​​
    } else if (property === 'sellerName' || property === 'seller') {
      defaultCondition.isReadOnly = false;
      defaultClause.column = 'sellerType';
      defaultClause.value = '5';
      if (selectedColumnValue && selectedColumnValue.trim() !== '') {​​​​​
        defaultClause1.column = 'sellerName';
        defaultClause1.value = selectedColumnValue;
      }​​​​​
    } else if (property === 'carrier' || property === 'carrierKey') {
      // [LFWM-2308] - changing carrier lookup condition as editable
      defaultCondition.isReadOnly = false;
      defaultClause.column = 'carrierType';
      defaultClause.value = '3';
      if (selectedColumnValue && selectedColumnValue.trim() !== '') {​​​​​
        defaultClause1.column = 'carrierKey';
        defaultClause1.value = selectedColumnValue;
      }​​​​​
    }
    else if (property === 'packKey') {
      /* Added this line of code for setting the searchCriteria in the filter of packKey lookup
   Added this line of code as when searching with
     a packKey = '' or packKey = '*' , no results are obtained instead of getting all packKeys
    Because Packkey uses Generic LoadByPage */
    if (this.isOpenLookup && selectedColumnValue && selectedColumnValue.trim() !== '') {
    defaultCondition.isReadOnly = false;
    defaultCondition.isMandatory = false;
    defaultClause.column = 'packKey';
    defaultClause.value = selectedColumnValue;
  } else {
       return defaultSearchCriteria;
    }
    }
    else if(property ==='PalletType'){
      defaultClause.column = 'storerKey';
      let selectedStorer = this.dataService.primaryDataMap['storerKey'].cVal;
      if (selectedStorer === '') {
        selectedStorer = '*';
      }
      defaultClause.value = selectedStorer;
      defaultClause2.operation = '=';
      defaultClause2.column = 'facility';
      let selectedFacility = this.dataService.primaryDataMap['facility'].cVal;
      if (selectedFacility === '') {
        selectedFacility = '*';
      }
      defaultClause2.value=selectedFacility;
      if (selectedColumnValue && selectedColumnValue.trim() !== '') {​​​​​
        defaultClause1.column = 'PalletType';
        defaultClause1.value = selectedColumnValue;
      }​​​​​
    }
    defaultClause.operation = '=';
    defaultCondition.clauses = [defaultClause];
    defaultCondition.operator = 'AND';
    defaultSearchCriteria.conditions.push(defaultCondition);
    if (this.isOpenLookup) {
      if(defaultClause2.column && defaultClause2.value){
        const defaultCondition2 = this.createSearchCondition(3);
        defaultCondition2.isReadOnly = false;
        defaultCondition2.isMandatory = false;
        defaultClause2.operation = '=';
        defaultCondition2.clauses = [defaultClause2];
        defaultCondition2.operator = 'AND';
        defaultSearchCriteria.conditions.push(defaultCondition2);
      }
    if (defaultClause1.column && defaultClause1.value) {​​​​​
      const defaultCondition1 = this.createSearchCondition(2);
      defaultCondition1.isReadOnly = false;
      defaultCondition1.isMandatory = false;
      defaultClause1.operation = '=';
      defaultCondition1.clauses = [defaultClause1];
      defaultCondition1.operator = 'AND';
      defaultSearchCriteria.conditions.push(defaultCondition1);
    }​​​​

    ​}
    return defaultSearchCriteria;
  }


  protected createLookupParamsForColumn(property: any) {
    const lookupParams = new SearchParams();
    lookupParams.isFullFetch = true;
    lookupParams.columnCount = 10;
    lookupParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.showIdAsAHyperLink = true;
    tableConfig.supportFiltering = true;
    lookupParams.dataTableConfig = tableConfig;
    if (property === 'storerKey' || property === 'storerName') {
      lookupParams.tableId = 'storertd';
      lookupParams.idProperty = 'storerName';
    } else if (property === this.getSkuProperty(property)) {
      lookupParams.tableId = 'commoditytd';
      lookupParams.idProperty = 'sku';
    } else if (property === 'toLoc') {
      lookupParams.tableId = 'locationtd';
      lookupParams.idProperty = 'locId';
    } else if (property === 'putawayLoc') {
      lookupParams.tableId = 'locationtd';
      lookupParams.idProperty = 'locId';
    } else if (property === 'sellerName' || property === 'seller') {
      lookupParams.tableId = 'sellertd';
      lookupParams.idProperty = 'sellerName';
    } else if (property === 'carrier' || property === 'carrierKey') {
      lookupParams.tableId = 'carriertd';
      lookupParams.idProperty = 'carrierKey';
    } else if (property === 'packKey') {
      //  Added this line of code for setting the tableId in lookup of packKey
      lookupParams.tableId = 'PACKLOOKUPTD';
      lookupParams.idProperty = 'packKey';
    }
    else if(property ==='PalletType'){
      lookupParams.tableId = 'palletTypetd';
      lookupParams.idProperty = 'PalletType';
    }
    return lookupParams;
  }

  protected handleLookupEvent(event: SearchEvent, property: any, currentColumnValue: any, currentRowCells: any) {
    super.handleLookupEvent(event, property, currentColumnValue, currentRowCells);
    this.dataService.getDetailsSearchService().getPagedData().aggridApi.refreshCells({ force: true });
    if (property === this.getSkuProperty(property)) {
      const row = { cells: currentRowCells };
      this.autoPopulate(row, 'packKey');
      if (this.dataService.primarySearchParams.tableId === 'asntd' || this.dataService.primarySearchParams.tableId === 'trtd') {
        this.autoPopulate(row, 'sku'); // for autopopulating location last value on change of sku for asn & trade returns
      }
    }
    //LFWM-3428--CN - NIKESDC - Hold channel checkbox as default in ASN creation
    if (this.dataService.primarySearchParams.tableId === 'asntd' && property=='storerKey') {
      this.setDefaultValues(event.selectedItemId);
    }
  }

  public setDefaultValues(storerKey: string) {
    const configKey1 = 'ChannelInventoryMgmt';
    const configKey2 = 'ASNDefaultHoldChannel';
    this.backendService.validationForFields(configKey1, storerKey)
      .subscribe((response: any) => {
        if (response['hasRights'] == 'Y') {
          this.backendService.validationForFields(configKey2, storerKey)
            .subscribe((responseN: any) => {
              if (responseN['hasRights'] == 'Y') {
                this.dataService.primaryDataMap['holdChannel'].cVal = '1';
              }
              else {
                this.dataService.primaryDataMap['holdChannel'].cVal = '0';
              }
            });
        }
        else {
          this.dataService.primaryDataMap['holdChannel'].cVal = '0';
        }
      });
  }

  protected validateBeforeLookup(currentRow: any, property: any): boolean {
    if (property === this.getSkuProperty(property)) {
      const selectedStorer = this.dataService.primaryDataMap['storerKey'].cVal;
      if (selectedStorer === null || selectedStorer === '') {
        this.alertService.clearAll().error('Please select a storer.');
        return false;
      }
    }
    return true;
  }

  // This method is called first time to populate any restriceted values before edit mode
  public populateRestrictedValues(pageRows: any, colName: any) {
    switch (colName) {
      case 'packKey': {
        if (this.dataService.getPrimaryDataIdValue()) {
          const asnId = this.dataService.getPrimaryDataIdValue();
          this.backendService.populateRestrictedValues(asnId).subscribe((res: any) => {
            // this.dataService.lookupMap.packKeys = {};
            this.dataService.lookupMap.packKeys = res;
            if (pageRows && pageRows.length > 0 ) {
              pageRows.forEach((row: any) => {
                if (row.cells['uom']) {
                  row.cells['uom'].cOptions = this.fetchOptionsValues(this.dataService.lookupMap.packKeys, row.cells['packKey'].cVal);
                  row.cells['uom'].cValOldUOM = row.cells['uom'].cVal.trim();
                  row.cells['uom'].isLoading = false;
                  //row.cells['uom'].cVal = row.cells['uom'].cVal.trim();
                }
              });
            }
          });
          if (pageRows && pageRows.length > 0 ) {
            pageRows.forEach((row: any) => {
              if (row.cells['uom']) {
                row.cells['uom'].isLoading = true;
              }
            });
          }
        }
        break;
      }
    }
  }
  /* Start LFWM-954(Trimmed white sace- not a best solution,it should handle in backend or database) :
  This method is used to set options values for dropdown irrespective of space */
  public fetchOptionsValues(dataList: any, key: string) {
    let selectedValue = null;
    const dataListKeys = Object.keys(dataList);
    for (let i = 0; i < dataListKeys.length; i++) {
      if (dataListKeys[i].trim() === key.trim()) {
        selectedValue = dataList[dataListKeys[i]];
        break;
      }
    }
    return this.trimKeyValues(selectedValue);
  }
  public trimKeyValues(dataList: any) {
    if (dataList) {
      dataList.forEach((data: any) => {
        data.key = data.key.trim();
      });
    }
    return dataList;
  }
  /* End LFWM-954 : This method is used to set options values for dropdown irrespective of space */
  public populateAllRestrictedValues(pageRows: any) {
    // either iterate on meatdata and call for all ea columns or
    // make call to each RestrictedValue based columns in this case;
    this.populateRestrictedValues(pageRows, 'packKey');
    // this.populateRestrictedValues(pageRows, 'other column');
  }

  public autoPopulate(row: any, colName: any) {
    if (colName === 'packKey') {
      row.cells['uom'].isLoading = true;
      const packKeyVal = row.cells[colName].cVal;
      if (packKeyVal === '') {
        row.cells['uom'].cOptions = null;
        // set to null so that it uses default uom values from columnMetadata
        row.cells['uom'].cVal = '';
        row.cells['uom'].cValOldUOM = '';
        row.cells['uom'].isLoading = false;
        row.cells['packKey'].isValueInvalid = false;
        row.focusedCellId = 'uom';
        return;
      }
      if (this.dataService.lookupMap.packKeys && this.fetchOptionsValues(this.dataService.lookupMap.packKeys, packKeyVal)) {
        // LFWM-954
        const cOptions = this.fetchOptionsValues(this.dataService.lookupMap.packKeys, packKeyVal);
        row.cells['uom'].cOptions = cOptions;
        row.cells['uom'].isLoading = false;
        if (cOptions.length > 0) {
          row.cells['packKey'].isValueInvalid = false;
          // row.cells['uom'].cValPrev = row.cells['uom'].cVal;
          row.cells['uom'].cVal = cOptions[0].key;
          row.cells['uom'].cValPrev = cOptions[0].key;
          row.cells['uom'].cValOldUOM = cOptions[0].key;
          row.cells['uom'].isEdited = true;
          /* [LFWM-2947] - commenting below code because expected qty and received qty
          should not default to 0 when tabout from packkey */
          /* row.cells['expectedQty'].cVal = 0;
          row.cells['receivedQty'].cVal = 0;
          row.cells['expectedQty'].isEdited = true;
          row.cells['receivedQty'].isEdited = true;
          row.cells['expectedQty'].cValPrev = 0;
          row.cells['receivedQty'].cValPrev = 0; */
          row.focusedCellId = 'uom';
        } else {
          row.cells['packKey'].isValueInvalid = true;
          row.cells['uom'].cVal = '';
          row.cells['uom'].cValPrev = '';
          row.cells['uom'].cValOldUOM = '';
          row.cells['uom'].isEdited = true;
          /* [LFWM-2947] - commenting below code because expected qty and received qty
          should not default to 0 when tabout from packkey */
          /* row.cells['expectedQty'].cVal = 0;
          row.cells['receivedQty'].cVal = 0;
          row.cells['expectedQty'].isEdited = true;
          row.cells['receivedQty'].isEdited = true;
          row.cells['expectedQty'].cValPrev = 0;
          row.cells['receivedQty'].cValPrev = 0; */
          row.focusedCellId = 'packKey';
        }
      } else {
        this.backendService.autoPopulate(packKeyVal)
          .subscribe((res: any) => {
            // JIRA 1076
            const formatedRes = {}; // stores the response with trimmed keys
            if (res) {
              Object.keys(res).forEach((key: any) => {
                formatedRes[key.trim()] = res[key];
              });
            }
            // this.dataService.lookupMap.packKeys = {};
            if (!this.dataService.lookupMap.packKeys) { // If null initialise
              this.dataService.lookupMap.packKeys = {};
            }
            // packKeyVal is trimmed to remove space
            const cOptions = (res && formatedRes[packKeyVal.trim()]) ? formatedRes[packKeyVal.trim()] : [];
            this.dataService.lookupMap.packKeys[packKeyVal] = cOptions;
            row.cells['uom'].cOptions = cOptions;
            row.cells['uom'].isLoading = false;
            if (cOptions.length > 0) {
              row.cells['packKey'].isValueInvalid = false;
              // row.cells['uom'].cValPrev = row.cells['uom'].cVal;
              row.cells['uom'].cVal = cOptions[0].key;
              row.cells['uom'].cValPrev = cOptions[0].key;
              row.cells['uom'].cValOldUOM = cOptions[0].key;
              row.cells['uom'].isEdited = true;
              /* [LFWM-2947] - commenting below code because expected qty and received qty
              should not default to 0 when tabout from packkey */
              /* row.cells['expectedQty'].cVal = 0;
              row.cells['receivedQty'].cVal = 0;
              row.cells['expectedQty'].isEdited = true;
              row.cells['receivedQty'].isEdited = true;
              row.cells['expectedQty'].cValPrev = 0;
              row.cells['receivedQty'].cValPrev = 0; */
              row.focusedCellId = 'uom';
            } else {
              row.cells['packKey'].isValueInvalid = true;
              row.cells['uom'].cVal = '';
              row.cells['uom'].cValPrev = '';
              row.cells['uom'].cValOldUOM = '';
              row.cells['uom'].isEdited = true;
              /* [LFWM-2947] - commenting below code because expected qty and received qty
              should not default to 0 when tabout from packkey */
              /* row.cells['expectedQty'].cVal = 0;
              row.cells['receivedQty'].cVal = 0;
              row.cells['expectedQty'].isEdited = true;
              row.cells['receivedQty'].isEdited = true;
              row.cells['expectedQty'].cValPrev = 0;
              row.cells['receivedQty'].cValPrev = 0; */
              row.focusedCellId = 'packKey';
            }
          });
      }
    } else if (colName === 'uom') {
      if (row.cells[colName].cVal === '') {
        row.cells[colName].isValueInvalid = true;
        row.focusedCellId = colName;
        return;
      } else if (row.cells[colName].cValOldUOM === '') {
        // if packkey is reset do not call ComputeUOM
        row.cells[colName].isValueInvalid = false;
        row.focusedCellId = 'expectedQty';
        return;
      }
      row.cells[colName].isValueInvalid = false;
      row.cells['expectedQty'].isLoading = true;
      row.cells['receivedQty'].isLoading = true;
      const oldUomVal = row.cells[colName].cValOldUOM;
      const newUomVal = row.cells[colName].cVal;
      const packKeyVal = row.cells['packKey'].cVal;
      // cvalprev=cval is set from editkeypresslistner
      let fromExpectedQty = row.cells['expectedQty'].cVal;
      let fromReceivedQty = row.cells['receivedQty'].cVal;
      const tableId = this.dataService.primarySearchParams.tableId;
      if (fromExpectedQty === 0 && fromReceivedQty === 0) {
        row.cells['expectedQty'].isValueInvalid = false;
        row.cells['receivedQty'].isValueInvalid = false;
        row.cells['expectedQty'].isLoading = false;
        row.cells['receivedQty'].isLoading = false;
        row.focusedCellId = 'expectedQty';
        return; // return if both values are zero. i.e no service call reqd
      }
      let useMasterUOM = false;
      const uomScreens = ['asntd', 'trtd', 'ixdocktd', 'oxdocktd'];
      // LFWM-3586 - In the above screens, we are using master uom qty in compute api.
      if (uomScreens.includes(this.dataService.primarySearchParams.tableId)) {
        useMasterUOM = !row.cells['expectedQty'].isEdited && !row.cells['receivedQty'].isEdited;
      }
      if (useMasterUOM) {
        fromExpectedQty = row.cells['expectedMasterQty'].cVal;
        fromReceivedQty = row.cells['receivedMasterQty'].cVal;
      }
      // LFWM-3191- passing tableId in the request
      const reqObj = {
        fromExpectedQty: fromExpectedQty ? fromExpectedQty : 0,
        fromReceivedQty: fromReceivedQty ? fromReceivedQty : 0,
        fromUOM: useMasterUOM ? '' : oldUomVal,
        toUOM: newUomVal,
        packKey: packKeyVal,
        tableId: tableId,
        useMasterUOM
      };
      this.backendService.autoPopulateUOMFeilds(reqObj)
        .subscribe((res: any) => {
          if (res.statusCode === 200 && res.statusMessage === 'SUCCESS') {
            row.cells['expectedQty'].cValPrev = row.cells['expectedQty'].cVal;
            row.cells['receivedQty'].cValPrev = row.cells['receivedQty'].cVal;
            row.cells['expectedQty'].cVal = res.toExpectedQty;
            row.cells['receivedQty'].cVal = res.toReceivedQty;
            if (!uomScreens.includes(this.dataService.primarySearchParams.tableId)) {
              // LFWM-3586 - In uomScreens list, we are setting isEdited true only when user modifies the field.
              // Can't change the flag on compute api response.
              row.cells['expectedQty'].isEdited = true;
              row.cells['receivedQty'].isEdited = true;
            }
            row.cells['expectedQty'].isValueInvalid = false;
            row.cells['receivedQty'].isValueInvalid = false;
            row.cells['expectedQty'].isLoading = false;
            row.cells['receivedQty'].isLoading = false;
            row.focusedCellId = 'expectedQty';
          } else {
            this.alertService.clearAll().error('Could not fetch expectedQty & receivedQty on UOM change');
            row.cells['expectedQty'].isValueInvalid = true;
            row.cells['receivedQty'].isValueInvalid = true;
            row.cells['expectedQty'].isLoading = false;
            row.cells['receivedQty'].isLoading = false;
            row.focusedCellId = 'uom';
          }
        });
    } else if (colName === 'sku') { // to fetch value for location last on commodity change in ASN and trade returns Detail page
      const facility = this.dataService.primaryDataMap['facility'].cVal;
      const storerKey = this.dataService.primaryDataMap['storerKey'].cVal;
      const sku = row.cells['sku'].cVal;
      const docType = this.dataService.getDocType();
      const optionValueList = {
        key: 'docType',
        value: docType
      };
      let configKey;
      // LFWM-3191- passing tableId in the request.
      const tableId = this.dataService.primarySearchParams.tableId;
      if (this.dataService.primarySearchParams.tableId === 'asntd') {
        configKey = 'DefaultRcptLOC';
      } else if (this.dataService.primarySearchParams.tableId === 'trtd') {
        configKey = 'QCLocation';
      }

      this.backendService.getLocationLast(facility, storerKey, configKey, sku, optionValueList, tableId).subscribe((resp: any) => {
        if (resp.statusCode === 200 && resp.statusMessage === 'SUCCESS') {
          if (resp.values !== null) {
            row.cells['toLoc'].cVal = resp.values[0].cVal;
            row.cells['toLoc'].isEdited = true;
            row.cells['toLoc'].isValueInvalid = false;
            row.cells['toLoc'].isLoading = false;
            row.focusedCellId = 'toLoc';
          }
        } else {
          this.alertService.clearAll().error('Could not fetch Location last');
          row.cells['toLoc'].isValueInvalid = true;
          row.cells['toLoc'].isLoading = true;
          row.focusedCellId = 'toLoc';
        }
      });
    } else if (colName === 'expectedQty') {
      // LFWM-2014-called whenever a value is changed in duplicated line's expectedQty
      if (row.duplicatedFromRow && !(isNaN((row.cells['expectedQty'].cVal)))) {
        this.dataService.detailsSearchService.getPagedData().pageRows.forEach((lineitem: any, index: any) => {
          // from parent row , duplicated line's expectedQty value has to be reduced
          if (lineitem.cells['receiptLineNumber'].cVal === row.duplicatedFromRow) {
            lineitem.cells['expectedQty'].cValPrev = lineitem.cells['expectedQty'].cVal;
            lineitem.cells['expectedQty'].cVal = (lineitem.cells['expectedQty'].cVal - row.cells['expectedQty'].cVal).toFixed(6);
            lineitem.cells['expectedQty'].isEdited = (lineitem.cells['expectedQty'].cVal !== lineitem.cells['expectedQty'].cValOrig);
            lineitem.isEdited = true;
            if (!row.cells['expectedQty'].cVal) {
              row.cells['expectedQty'].cVal = (0).toFixed(2); // when empty value entered,set to 0.000000
            }
            // called to refresh cells when,value is changed in parent line according to the duplicated expected quantity
            this.dataService.getDetailsSearchService().getPagedData().aggridApi.refreshCells({ force: true });
          }
        });
      }
    }
  }

  protected getLookupModalTitle(property) {
    switch (property) {

      case 'storerKey': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('storer_Id'));

      case 'sku': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('lbl_commodity'));

      case 'commodity': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('lbl_commodity'));

      case 'toLoc': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('loc_id'));

      case 'putawayLoc': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('loc_id'));

      case 'sellerName': return this.resourceService.get('maintain_storer');

      case 'carrier': return this.resourceService.get('maintain_storer');

      case 'packKey': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('packkey'));

      case 'PalletType': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('pallet_type'));

      default: return property;
    }
  }
  //[LFWM-1984][Lookup screens search accordion][Added funtion to map subtitle in lookup component]
  protected getLookupModalSubTitle(property) {
    switch (property) {
      case 'storerKey': return this.resourceService.get('storer_Id').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'sku': return this.resourceService.get('lbl_commodity').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'commodity': return this.resourceService.get('lbl_commodity').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'toLoc': return this.resourceService.get('loc_id').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'putawayLoc': return this.resourceService.get('loc_id').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'seller': return this.resourceService.get('maintain_storer').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'carrier': return this.resourceService.get('maintain_storer').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'packKey': return this.resourceService.get('packkey').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'sellerName': return this.resourceService.get('maintain_storer').concat(' ').concat(this.resourceService.get('lbl_search'));
      default: return property;
      }
  }

  protected getNextPropertyToFocus(property) {
    switch (property) {

      case 'storerKey': return 'facility';

      case 'sku': return 'alternateSku';

      case 'commodity': return 'packKey';

      case 'toLoc': return 'putawayLoc';

      case 'putawayLoc': return 'tariffKey';

      case 'sellerName': return 'sellersCompany';

      case 'carrier': return 'CarrierName';

      default: return property;
    }
  }

  protected getDependantMapForProperty(property: string) {
    let propMap;
    if (property === 'storerKey') {
      propMap = {
        'storerKey': 'storerName'
      };
    } else if (property === 'sku') {
      propMap = {
        'sku': 'sku',
        'description': 'skuDescr',
        'alternateSku': 'altskuid',
        'packKey': 'packkey'
      };
    } else if (property === 'commodity') {
      propMap = {
        'commodity': 'sku',
        'commodityDescription': 'skuDescr',
        'packKey': 'packkey'
      };
    } else if (property === 'toLoc') {
      propMap = {
        'toLoc': 'locId'
      };
    } else if (property === 'putawayLoc') {
      propMap = {
        'putawayLoc': 'locId'
      };
    } else if (property === 'sellerName') {
      propMap = {
        'sellerName': 'sellerName', 'sellersCompany': 'sellerCompany',
        'sellerAddress1': 'sellerAddress1', 'sellerAddress2': 'sellerAddress2',
        'sellerAddress3': 'sellerAddress3', 'sellerAddress4': 'sellerAddress4',
        'sellerCity': 'sellerCity', 'sellerState': 'sellerState',
        'sellerZip': 'sellerZip', 'sellerCountry': 'sellerCountry',
        'sellerContact1': 'SellerContact1', 'sellerContact2': 'SellerContact2',
        'sellerPhone1': 'SellerPhone1', 'sellerPhone2': 'SellerPhone2',
        'sellerFax1': 'SellerFax1', 'sellerFax2': 'SellerFax2',
        'sellerEmail1': 'SellerEmail1', 'sellerEmail2': 'SellerEmail2'
      };
    } else if (property === 'carrier') {
      propMap = {
        'carrier': 'carrierKey', 'CarrierName': 'carrierName',
        'carrierAddress1': 'carrierAddress1', 'carrierAddress2': 'carrierAddress2',
        'carrierCity': 'carrierCity', 'carrierState': 'carrierState',
        'carrierZip': 'carrierZip'
      };
    } else if (property === 'packKey') {
      propMap = {
        'packKey': 'packKey'
      };
    }
    else if(property === 'PalletType'){
      propMap = {
        'PalletType': 'PalletType'
      };
    }
    else {
      propMap = {};
    }
    return propMap;
  }

  /*LFWM- 1125 : This method formats the expected received and missing qty to 6
  decimal places */
  /*LFWM- 2307 :Changes made to format the expected received and missing qty to 2
  decimal places */
  public formatQty(propertyName, row) {
    const pattern = /^[0-9]\d*(\.\d*)?$/;
    let itemValue;
    this.dataService.getDetailsSearchService().getPagedData().pageRows.forEach(item => {
      if (item.cells[propertyName]) {
        if (pattern.test(item.cells[propertyName].cVal)) {
          if (this.dataService.entityConfig.getPrimarySearchParams().tableId === 'asntd') {
            itemValue = item.cells[propertyName].cVal;
            let itemSplit;
            // In create asn, when expected qty is empty it is passed as 0
            itemValue = itemValue.toString();
            if (itemValue.includes('.')) {
              itemSplit = itemValue.split('.');
              if (itemSplit[1].length > 2) {
                itemValue = Math.round(item.cells[propertyName].cVal * 100) / 100;
              }else {
                itemValue = Number(item.cells[propertyName].cVal);
              }
            }else {
              itemValue = Number(item.cells[propertyName].cVal);
            }

          }else {
            itemValue = Math.floor(item.cells[propertyName].cVal);
          }
          if (propertyName === 'otherUnit1') {
            item.cells[propertyName].cVal = (itemValue).toFixed(1);
          } else if (propertyName === 'expectedQty' || propertyName === 'receivedQty') {
            item.cells[propertyName].cVal = (itemValue).toFixed(2);
          }else {
            item.cells[propertyName].cVal = (itemValue).toFixed(6);
          }
        } else {
          return;
        }
      }
    });
    row.cells.forEach(cell => {
      let cellValue;
      if (cell.cName === propertyName) {
        if (pattern.test(cell.cVal)) {
           if (this.dataService.entityConfig.getPrimarySearchParams().tableId === 'asntd') {
            cellValue = cell.cVal;
            let itemSplit;
            cellValue = cellValue.toString();
            if (cellValue.includes('.')) {
             itemSplit = cellValue.split('.');
                if (itemSplit[1].length > 2) {
                  cellValue = Math.round(cell.cVal * 100) / 100;
                }else {
                  cellValue = Number(cell.cVal);
                }
          }else {
            cellValue = Number(cell.cVal);
            }
          }else {
            cellValue = Math.floor(cell.cVal);
          }
          if (propertyName === 'otherUnit1') {
            cell.cVal = (cellValue).toFixed(1);
          } else if (propertyName === 'expectedQty' || propertyName === 'receivedQty') {
            cell.cVal = (cellValue).toFixed(2);
          }else {
            cell.cVal = (cellValue).toFixed(6);
          }
        } else {
          return;
        }
      }
    });
  }
  public propertyValueChanged(event: PropertyChangeEvent): boolean {
    if (event.property === 'receiptLineLottable04' ||
       event.property === 'receiptLineLottable05' ||
       event.property === 'receiptLineLottable13' ||
       event.property === 'receiptLineLottable14' ||
       event.property === 'receiptLineLottable15'
       ) {
         let columnMeta: any[];
         const columList = this.dataService.detailsSearchService.getMetadata().columnList;
         columList.forEach(element => {
           if (element.propertyName === event.property) {
             columnMeta = element;
           }
         });
         this.lottableRecalculate(event, event.row, columnMeta);
    }
    // [LFWM-3096] - when changing receiptDate copying the same to receiptLineLottable05 in line item
    if (event.property === 'receiptDate') {
      const configKey = 'DefaultReceiptDateOnLottables';
      // [UWP-53062][PROD][China] TypeError: Cannot read properties of undefined (reading 'storerKey')
      const storerKeyVal = this.dataService.primaryDataMap ? this.dataService.primaryDataMap[COMMONPROPERTIES.STORER_KEY].cVal : '';
      this.backendService.getStorerConfiguration(storerKeyVal, configKey).subscribe(resp => {
        if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
          if (resp['hasRights'] === 'Y') {
            // this.dataService is undefined
            if(this.dataService.detailsSearchService) {
              this.dataService.detailsSearchService.getPagedData().pageRows.forEach(row => {
                if (row.cells['lottable05Label'].cVal === 'RCP_DATE') {
                  row.cells['receiptLineLottable05'].cVal = this.dataService.primaryDataMap[event.property].cVal.substr(0, 10);
                  // we are taking modified line items in save based on this isEdited flag [editable rows]
                  row.isEdited = true;
                  // refreshing the table to display the updated value in UI before save
                  this.dataService.getDetailsSearchService().publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
                }
              });
            }
          }
        }
      });
    }

     // [LFWM-3097] - when changing facility copying the location from facility table in userdefined04 column to row in each line item
    if (event.property === 'facility') {
      const configKey = 'ASNReceiptLocBasedOnFacility';
      // [UWP-53062][PROD][China] TypeError: Cannot read properties of undefined (reading 'storerKey')
      const storerKeyVal = this.dataService.primaryDataMap ? this.dataService.primaryDataMap[COMMONPROPERTIES.STORER_KEY].cVal : '';

      this.backendService.getStorerConfigurationForFacility(event.value, storerKeyVal, configKey).subscribe(resp => {
        if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
          if (resp['hasRights'] === 'Y') {
            this.backendService.getFacilityLocation(event.value).subscribe((respLoc:any) => {
              if (respLoc && respLoc.trim().length>0) {
                    this.dataService.detailsSearchService.getPagedData().pageRows.forEach(row => {
                        row.cells['toLoc'].cVal = respLoc;
                        row.isEdited = true;
                        // refreshing the table to display the updated value in UI before save
                        this.dataService.getDetailsSearchService().publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
                    });
                }
              });
          }
        }
      });
    }
    return true;
  }

  // public propertyValueChanged(event: PropertyChangeEvent): boolean {

  //    /*// lfwm-2184 , added to check if new added line item,'PRE' is passed as 'prePost' for newly added line items
  //    if (event.row && event.row.isNewRow) {
  //     this.isnewLine = true;
  //   } else {
  //     this.isnewLine = false;
  //   }*/
  //   if (event.type === MANUAL_EDIT && event.value) {
  //     const lottabelLabelMap = {
  //       'receiptLineLottable01': 'lottable01',
  //       'receiptLineLottable02': 'lottable02',
  //       'receiptLineLottable03': 'lottable03',
  //       'receiptLineLottable04': 'lottable04',
  //       'receiptLineLottable05': 'lottable05',
  //       'receiptLineLottable06': 'lottable06',
  //       'receiptLineLottable07': 'lottable07',
  //       'receiptLineLottable08': 'lottable08',
  //       'receiptLineLottable09': 'lottable09',
  //       'receiptLineLottable10': 'lottable10',
  //       'receiptLineLottable11': 'lottable11',
  //       'receiptLineLottable12': 'lottable12',
  //       'receiptLineLottable13': 'lottable13',
  //       'receiptLineLottable14': 'lottable14',
  //       'receiptLineLottable15': 'lottable15'
  //     };
  //     let request: any = {};
  //     let lottableLabelValue: any = '';
  //     const recieptlottableList = {};
  //     let isproceed: boolean = false; // true - when changing lottable field
  //     if (Object.keys(lottabelLabelMap).includes(event.property)) {
  //       isproceed = true;
  //     }
  //     if (isproceed) {
  //       for (const lottable of Object.keys(lottabelLabelMap)) {
  //         if (lottable === event.property) {
  //           recieptlottableList[lottabelLabelMap[event.property]] = event.value;
  //           if (event.row.cells[lottabelLabelMap[lottable] + 'Label'].cVal) {
  //             lottableLabelValue = event.row.cells[lottabelLabelMap[lottable] + 'Label'].cVal;
  //           }
  //         } else {
  //           recieptlottableList[lottabelLabelMap[lottable]] = event.row.cells[lottable].cVal;
  //         }
  //       }
  //       request = {
  //         'listName': lottabelLabelMap[event.property],
  //         'storerKey': this.dataService.primaryDataMap['storerKey'].cVal,
  //         'sku': event.row.cells['sku'].cVal,
  //         'sourceKey': this.dataService.primaryDataMap['receiptKey'].cVal
  //           + event.row.cells['receiptLineNumber'].cVal,
  //         'sourceType': 'RECIEPT',
  //         'lottableLabel': lottableLabelValue,
  //         [lottabelLabelMap[event.property]]: event.value,
  //         'receiptLottableList': recieptlottableList,
  //         'prePost': '',
  //         'updateTable': 'RECEIPTDETAIL',
  //         'warningNo': 0,
  //         'proceedWithWarning': 'N'
  //       };
  //       this.backendService.lottableReCalculate(request)
  //         .subscribe((res: any) => {
  //           if (res['errorType'] === '2' ) {
  //             this.confirmDialogService.confirmDialog(res['errMsg'])
  //             .subscribe((isConfirmed: any) => {
  //               if (isConfirmed) {
  //                 request['warningNo'] = res['warningNo'];
  //                 request['proceedWithWarning'] = 'Y';
  //                 this.recalculate(event, request, lottabelLabelMap);
  //               } else {
  //                 return false;
  //               }
  //               });
  //             }
  //           if (res.statusCode === 200 && res.statusMessage === 'SUCCESS') {
  //             if (res['err'] === 0) {
  //               for (const lottable of Object.keys(lottabelLabelMap)) {
  //                 if (res[lottabelLabelMap[lottable]]) {
  //                   event.row.cells[lottable].cVal = res[lottabelLabelMap[lottable]];
  //                   event.row.isEdited = true;
  //                 }
  //               }
  //             } else {
  //               this.alertService.clearAll().error(res['errMsg']);
  //             }
  //           }
  //         });
  //     }
  // }
  // return true;
  // }

  // public recalculate (event, request, lottabelLabelMap) {
  //   this.backendService.lottableReCalculate(request)
  //   .subscribe((res: any) => {
  //     if (res['errorType'] === '2' ) {
  //       this.confirmDialogService.confirmDialog(res['errMsg'])
  //       .subscribe((isConfirmed: any) => {
  //         if (isConfirmed) {
  //           request['warningNo'] = res['warningNo'];
  //           request['proceedWithWarning'] = 'Y';
  //           this.recalculate(event, request, lottabelLabelMap);
  //         } else {
  //           return false;
  //         }
  //         });
  //       } else if (res['errorType'] === 0) {
  //         this.alertService.clearAll().error(res['errMsg']);
  //       }
  //     if (res.statusCode === 200 && res.statusMessage === 'SUCCESS') {
  //       if (res['errorType'] === 1) {
  //         for (const lottable of Object.keys(lottabelLabelMap)) {
  //           if (res[lottabelLabelMap[lottable]]) {
  //             event.row.cells[lottable].cVal = res[lottabelLabelMap[lottable]];
  //             event.row.isEdited = true;
  //           }
  //         }
  //       } else {
  //         this.alertService.clearAll().error(res['errMsg']);
  //       }
  //     }
  //   });
  // }




  public lottableRecalculate(event: any, row: any, columnMeta: any): boolean {
      const lottabelLabelMap = {
        'receiptLineLottable01': 'lottable01',
        'receiptLineLottable02': 'lottable02',
        'receiptLineLottable03': 'lottable03',
        'receiptLineLottable04': 'lottable04',
        'receiptLineLottable05': 'lottable05',
        'receiptLineLottable06': 'lottable06',
        'receiptLineLottable07': 'lottable07',
        'receiptLineLottable08': 'lottable08',
        'receiptLineLottable09': 'lottable09',
        'receiptLineLottable10': 'lottable10',
        'receiptLineLottable11': 'lottable11',
        'receiptLineLottable12': 'lottable12',
        'receiptLineLottable13': 'lottable13',
        'receiptLineLottable14': 'lottable14',
        'receiptLineLottable15': 'lottable15'
      };
      let request: any = {};
      let lottableLabelValue: any = '';
      const recieptlottableList = {};
      let isproceed: boolean = false; // true - when changing lottable field
      if (Object.keys(lottabelLabelMap).includes(columnMeta.propertyName)) {
        isproceed = true;
      }
      if (isproceed) {
        for (const lottable of Object.keys(lottabelLabelMap)) {
          if (lottable === columnMeta.propertyName) {
            recieptlottableList[lottabelLabelMap[columnMeta.propertyName]] = row.cells[lottable].cVal;
            if (row.cells[lottabelLabelMap[lottable] + 'Label'].cVal) {
              lottableLabelValue = row.cells[lottabelLabelMap[lottable] + 'Label'].cVal;
            }
          } else {
            recieptlottableList[lottabelLabelMap[lottable]] = row.cells[lottable].cVal;
          }
        }
        // LFWM-3191- adding tableId
        const tableId = this.dataService.primarySearchParams.tableId;
        request = {
          'listName': lottabelLabelMap[columnMeta.propertyName],
          'storerKey': this.dataService.primaryDataMap['storerKey'].cVal,
          'sku': row.cells['sku'].cVal,
          'sourceKey': this.dataService.primaryDataMap['receiptKey'].cVal
            + row.cells['receiptLineNumber'].cVal,
          'sourceType': 'RECEIPT',
          'lottableLabel': lottableLabelValue,
          [lottabelLabelMap[columnMeta.propertyName]]: row.cells[columnMeta.propertyName].cVal,
          'receiptLottableList': recieptlottableList,
          'prePost': '',
          'updateTable': 'RECEIPTDETAIL',
          'warningNo': 0,
          'proceedWithWarning': 'N',
          'tableId': tableId
        };
        this.backendService.lottableReCalculate(request)
          .subscribe((res: any) => {
            this.alertService.clearAll();
            // warningNo>0 => ask for the confirmation from user and call the same API
            if (parseInt(res['warningNo'], 10) > 0 && request['warningNo'] !== res['warningNo']) {
              if (res['errMsg']) {
                this.confirmDialogService.confirmDialog(res['errMsg'])
                  .subscribe((isConfirmed: any) => {
                    if (isConfirmed) {
                      request['warningNo'] = res['warningNo'];
                      request['proceedWithWarning'] = 'Y';
                      this.recalculate(event, request, lottabelLabelMap, row);
                    } else {
                      //added to reset the value of the property to the original value if confirmation is declined
                     // event.row.cells[event.property].cVal = event.row.cells[event.property].cValOrig;
                      return false;
                    }
                  });
              }
              /* errorType = 2 => warning
                errorType = 1 => success
                errorType = 0 => error
              */
              // if warningNo =0 alert with error Message
            } else if ((res['errorType'] === '2' || res['errorType'] === '1' || res['errorType'] === '0') && res['warningNo'] === 0) {
              if (res['errMsg']) {
                //added to reset the value of the property to the original value if confirmation is declined
               // event.row.cells[event.property].cVal = event.row.cells[event.property].cValOrig;
                this.alertService.clearAll().error(res['errMsg']);

              }
            }
            // if errorType =1 => success,map the result values to fields
            if (res['errorType'] === '1') {
              for (const lottable of Object.keys(lottabelLabelMap)) {
                if (res[lottabelLabelMap[lottable]]) {
                row.cells[lottable].cVal = res[lottabelLabelMap[lottable]];
                  row.isEdited = true;
                }
              }
            } else {
             // event.row.cells[event.property].cVal = event.row.cells[event.property].cValOrig;
              this.alertService.clearAll().error(res['errMsg']);
            }
          });
      }
    return true;
  }

  public recalculate(event, request, lottabelLabelMap, row) {
    this.backendService.lottableReCalculate(request)
      .subscribe((res: any) => {
        this.alertService.clearAll();
        if (parseInt(res['warningNo'], 10) > 0 && request['warningNo'] !== res['warningNo']) {
          if (res['errMsg']) {
            this.confirmDialogService.confirmDialog(res['errMsg'])
              .subscribe((isConfirmed: any) => {
                if (isConfirmed) {
                  request['warningNo'] = res['warningNo'];
                  request['proceedWithWarning'] = 'Y';
                  this.recalculate(event, request, lottabelLabelMap, row);
                } else {
                  //added to reset the value of the property to the original value if confirmation is declined
                 // event.row.cells[event.property].cVal = event.row.cells[event.property].cValOrig;
                  return false;
                }
              });
          }
        } else if ((res['errorType'] === '2' || res['errorType'] === '1') && res['warningNo'] === '0') {
          //added to reset the value of the property to the original value if confirmation is declined
         // event.row.cells[event.property].cVal = event.row.cells[event.property].cValOrig;
          this.alertService.clearAll().error(res['errMsg']);
        }
        if (res['errorType'] === '1') {
          for (const lottable of Object.keys(lottabelLabelMap)) {
            if (res[lottabelLabelMap[lottable]]) {
             row.cells[lottable].cVal = res[lottabelLabelMap[lottable]];
              row.isEdited = true;
            }
          }
        } else {
          this.alertService.clearAll().error(res['errMsg']);
          //added to reset the value of the property to the original value if confirmation is declined
          // event.row.cells[event.property].cVal = event.row.cells[event.property].cValOrig;
        }
      });
  }

  public focusOutListener(cell: any){
    if (cell.cName === 'externReceiptkey') {
      this.validateExternReceiptKeyConfig();
    }
  }

  public validateExternReceiptKeyConfig() {
    this.dataService.isExternReceiptKeyEnabled = false;
    // LFWM-3191- passing tableId in the request.
    const tableId = this.dataService.primarySearchParams.tableId;
    if (this.externReceiptKeyTableIds.includes(this.dataService.getPrimarySearchService().searchParams.tableId)) {
      const request = {
        'facility': this.dataService.primaryDataMap['facility'].cVal,
        'storerKey': this.dataService.primaryDataMap['storerKey'].cVal,
        'configKey': 'UPDATEXTERNRECEIPT2DETAIL',
        'sku': '',
        'optionValueList': [{
          'key': 'externReceiptkey',
          'value': this.dataService.primaryDataMap['externReceiptkey'].cVal
        }],
        'tableId': tableId
      };
      this.backendService.fetchExternReceiptKeyOnConfigKey(request).subscribe((exterReceiptKeyProp) => {
        if (exterReceiptKeyProp['statusCode'] === 200 && exterReceiptKeyProp['statusMessage'] === 'SUCCESS') {
          this.dataService.isExternReceiptKeyEnabled = exterReceiptKeyProp['isEnabled'] === 'Y';
          this.dataService.detailsSearchService.getPagedData().pageRows.forEach(row => {
            //row.cells['externReceiptKey'].cVal = this.dataService.isExternReceiptKeyEnabled ? this.dataService.primaryDataMap['externReceiptkey'].cVal : '';
            //LFWM-3435 - when we change externReceiptKey in receipt table, externReceiptKey in receipt detail table should not set to blank
            row.cells['externReceiptKey'].cVal = this.dataService.isExternReceiptKeyEnabled ?
                this.dataService.primaryDataMap['externReceiptkey'].cVal : row.cells['externReceiptKey'].cVal;
            row.isEdited = true;
          });
          // refreshing the table to display the updated value in UI before save
          this.dataService.getDetailsSearchService().publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
        }
        else {
          if (exterReceiptKeyProp.error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(exterReceiptKeyProp.error));
          }
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/services/receipt/receipt-data-editor.service.ts